import {
  type IAddress,
  type IBasketPrice,
  type IBasketProduct,
  type IHolidayPeriod,
  type IValidatedDiscount,
} from '@mahawi/eshop-common/dist/src/types';

export interface AddProduct {
  payload: {
    product: { uuid: string };
    count: number;
    discounts: {
      code: string;
    }[];
  };
}

export interface AddProductResponse {
  type: string;
  payload: {
    product: IBasketProduct;
    basketPrices: IBasketPrice[];
  };
}

export type AddProductCallback = (arg0: AddProductResponse) => void;

export interface RemoveProduct {
  payload: {
    product: { uuid: string };
    discounts: {
      code: string;
    }[];
  };
}

export interface RemoveProductResponse {
  type: string;
  payload: {
    product: { uuid: string };
    basketPrices: IBasketPrice[];
  };
}

export type RemoveProductCallback = (arg0: RemoveProductResponse) => void;

export interface SetDelivery {
  payload: {
    delivery: {
      fee: {
        withTax: number;
        withoutTax: number;
      };
    };
    packagesCount: number;
  };
}

export interface SetFields {
  payload: {
    billingAddress: IAddress;
    deliveryAddress: IAddress;
    termsAndConditions: boolean;
    deliveryAddressIsDifferent: boolean;
    heurekaCZShopCertification: boolean;
    marketingConsent: boolean;
    isForCompany: boolean;
    deliveryNote: string;
  };
}

export interface ValidateDiscountCodes {
  payload: {
    discounts: {
      code: string;
    }[];
    customerEmails?: string[];
  };
}

export interface ValidateDiscountCodesResponse {
  type: string;
  payload: {
    discounts: IValidatedDiscount[];
    basketPrices: IBasketPrice[];
  };
}

export type ValidateDiscountCodesCallback = (
  arg0: ValidateDiscountCodesResponse,
) => void;

export interface InitialStateResponse {
  type: string;
  payload: {
    products: IBasketProduct[];
    basketPrices: IBasketPrice[];
    holidayPeriod: IHolidayPeriod | null;
  };
}

export type InitialStateCallback = (arg0: InitialStateResponse) => void;

export interface SetDestinationCountryTypeIsoCode {
  payload: {
    destinationCountryTypeIsoCode: string;
  };
}

export enum EViesValidationStatus {
  Idle = 'idle',
  Pending = 'pending',
  Valid = 'valid',
  Invalid = 'invalid',
  Error = 'error',
}

export interface IViesValidation {
  status: EViesValidationStatus;
  vatNumber?: string;
  name?: string | null;
  address?: string | null;
}

export interface ValidateVies {
  payload: {
    countryCode: string;
    vatNumber: string;
  };
}

export interface ValidateViesResponse {
  type: string;
  payload: {
    isValid: boolean | null;
    vatNumber: string;
    name?: string | null;
    address?: string | null;
  };
}

export type ValidateViesCallback = (arg0: ValidateViesResponse) => void;

export interface IBasketState {
  inProgress: boolean;
  products: IBasketProduct[];
  delivery: {
    fee: {
      withTax: number;
      withoutTax: number;
    };
  };
  packagesCount: number;
  billingAddress: IAddress;
  deliveryAddress: IAddress;
  deliveryAddressIsDifferent: boolean;
  termsAndConditions: boolean;
  heurekaCZShopCertification: boolean;
  marketingConsent: boolean;
  discounts: IValidatedDiscount[];
  basketPrices: IBasketPrice[];
  deliveryNote: string;
  isForCompany: boolean;
  viesValidation: IViesValidation;
}
